import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/awsSample',
  component: layout,
  meta: {
    funcID: 'E0006',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'sampleInfo',
      name: `${pre}sampleInfo`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000601',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsSample/sampleInfo'),
    },
    {
      path: 'sampleInfo/:pageType/:amzSampleCode?',
      name: `${pre}sampleInfo-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzSampleNo = '新增' } = $route.query || {}
          return `样品信息${amzSampleNo ? ' | ' : ''}${amzSampleNo || ''}`
        },
        funcID: 'E000601',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/ecom/awsSample/sampleInfo/detail'),
    },
    {
      path: 'fabric',
      name: `${pre}fabric`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000602',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsSample/fabric'),
    },
    {
      path: 'fabric/:pageType/:fabricCode?',
      name: `${pre}fabric-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { fabricNo = '新增' } = $route.query || {}
          return `Amazon面料管理${fabricNo ? ' | ' : ''}${fabricNo || ''}`
        },
        funcID: 'E000602',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/ecom/awsSample/fabric/detail'),
    },
    {
      path: 'fabricReview',
      name: `${pre}fabricReview`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000603',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsSample/fabricReview'),
    },
    {
      path: 'fabricReview/:pageType/:fabricCode?',
      name: `${pre}fabricReview-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { fabricNo = '' } = $route.query || {}
          return `Amazon面料信息审核${fabricNo ? ' | ' : ''}${fabricNo || ''}`
        },
        funcID: 'E000603',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/ecom/awsSample/fabricReview/detail'),
    },
    {
      path: 'fabricSeries',
      name: `${pre}fabricSeries`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000604',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsSample/fabricSeries'),
    },
    {
      path: 'fabricSeries/:pageType/:fabricSeriesCode?',
      name: `${pre}fabricSeries-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { fabricSeriesNo = '新增' } = $route.query || {}
          return `Amazon面料系列管理${fabricSeriesNo ? ' | ' : ''}${fabricSeriesNo || ''}`
        },
        funcID: 'E000604',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/ecom/awsSample/fabricSeries/detail'),
    },
    {
      path: 'fabricSeriesReview',
      name: `${pre}fabricSeriesReview`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000605',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsSample/fabricSeriesReview'),
    },
    {
      path: 'fabricSeriesReview/:pageType/:fabricSeriesCode?',
      name: `${pre}fabricSeriesReview-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { fabricSeriesNo = '' } = $route.query || {}
          return `Amazon面料系列审核${fabricSeriesNo ? ' | ' : ''}${fabricSeriesNo || ''}`
        },
        funcID: 'E000605',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/ecom/awsSample/fabricSeriesReview/detail'),
    },
  ])('ecom-awsSample-'),
}
